import React, { forwardRef } from 'react';
import {
  PALETTE, FONT_SERIF, FONT_SANS, FONT_MONO,
  HaleMark, ToxIntelMark, Backplate, Eyebrow, Headline, Body, Rule, Bullet,
} from './primitives';

/* Asset 8 — Partner Graphic (Hale + The Agyekum Group)
 *
 * 1200×1200 square. Two-up partnership statement with the supporting
 * pathway copy. Used for grid posts and partnership announcements. */

const VB_W = 1200;
const VB_H = 1200;

const PartnerGraphicAsset = forwardRef(function PartnerGraphicAsset(_props, ref) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${VB_W} ${VB_H}`}
      width="100%"
      preserveAspectRatio="xMidYMid meet"
      role="img"
      aria-label="Hale and the Agyekum Group partnership graphic"
    >
      <Backplate w={VB_W} h={VB_H} />

      {/* Subtle coral wash bottom-right */}
      <g opacity={0.06}>
        <circle cx={1180} cy={1220} r={620} fill={PALETTE.CORAL} />
      </g>

      {/* Top lockup */}
      <ToxIntelMark x={64} y={84} fontSize={26} />
      <text x={VB_W - 64} y={84} textAnchor="end" fill={PALETTE.MUTED} fontFamily={FONT_MONO} fontSize={11} letterSpacing={2}>
        PARTNERSHIP · PILOT 2026
      </text>
      <Rule x1={0} x2={VB_W} y={116} />

      {/* Center brand lockup */}
      <g transform="translate(64,220)">
        <HaleMark x={0} y={0} w={220} h={94} fontSize={68} />
        <text x={244} y={62} fill={PALETTE.SLATE} fontFamily={FONT_SERIF} fontWeight={300} fontSize={120}>
          +
        </text>
        <text x={328} y={70} fill={PALETTE.SLATE} fontFamily={FONT_SERIF} fontWeight={700} fontSize={62}>
          The Agyekum Group
        </text>
      </g>

      {/* Headline */}
      <Eyebrow x={64} y={420} text="Independent scientific review" />
      <Headline x={64} y={520} text="Two pathways." size={92} />
      <Headline x={64} y={612} text="One scientific" size={92} />
      <Headline x={64} y={704} text="standard." size={92} italic color={PALETTE.CORAL} />

      <Body
        x={64}
        y={772}
        size={22}
        color={PALETTE.MUTED}
        lineHeight={1.45}
        text={[
          'Independent scientific review supporting Hale Reviewed™',
          'and Hale Verified™ pathways.',
        ]}
      />

      {/* Two pathway tiles */}
      <g transform="translate(64,880)">
        {[
          { k: 'Reviewed™', sub: 'Scientific governance activation', color: PALETTE.CORAL },
          { k: 'Verified™', sub: 'Documentation maturity',           color: PALETTE.SLATE },
        ].map((p, i) => (
          <g key={p.k} transform={`translate(${i * 552},0)`}>
            <rect x={0} y={0} width={520} height={180} fill="rgba(255,255,255,0.7)" stroke={PALETTE.RULE} />
            <rect x={0} y={0} width={6} height={180} fill={p.color} />
            <text x={32} y={56} fill={PALETTE.CORAL} fontFamily={FONT_MONO} fontSize={11} letterSpacing={2}>
              HALE
            </text>
            <text x={32} y={108} fill={PALETTE.SLATE} fontFamily={FONT_SERIF} fontWeight={700} fontSize={42}>
              {p.k}
            </text>
            <text x={32} y={146} fill={PALETTE.MUTED} fontFamily={FONT_SANS} fontSize={16}>
              {p.sub}
            </text>
          </g>
        ))}
      </g>

      <Rule x1={64} x2={VB_W - 64} y={VB_H - 80} />
      <text x={64} y={VB_H - 36} fill={PALETTE.MUTED} fontFamily={FONT_MONO} fontSize={11} letterSpacing={2}>
        HALE × TOXINTEL · INDEPENDENT SCIENTIFIC REVIEW PARTNER: THE AGYEKUM GROUP
      </text>
    </svg>
  );
});

export default PartnerGraphicAsset;
